import { render, staticRenderFns } from "./FactTableItem.vue?vue&type=template&id=b05e6bd2&scoped=true&"
import script from "./FactTableItem.vue?vue&type=script&lang=js&"
export * from "./FactTableItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b05e6bd2",
  null
  
)

export default component.exports